<template>
  <section class="company-selector">
    <b-field label="Search for a company" class="custom-auto-complete">
      <b-autocomplete
          rounded
          v-model="input"
          :data="companies"
          placeholder="Company name..."
          field="name"
          @select="option => selectCompany(option)"
          :autofocus="true"
      >
        <template slot="empty">No results found</template>
      </b-autocomplete>
    </b-field>
  </section>
</template>

<script>
export default {
  name: "company-selector",
  data() {
    return {
      input: '',
    }
  },
  computed: {
    companies() {
      return this.$store.state.company.companiesReduced;
    }
  },
  watch: {
    'input': _.debounce(function () {
      if (this.input && this.input.length >= 3) {
        this.$store.dispatch('company/getCompaniesReduced', {
          companySearchParam: this.input
        });
      }
    }, 500)
  },
  methods: {
    selectCompany(option) {
      if (option && option.id) {
        this.$emit('companySelected', option.id);
      }
    }
  }
}
</script>

<style scoped lang="scss">
.company-selector {
  width: 450px;
}

</style>